import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import RingBuilder from "../../assets/images/JC_Icon_RingBuilder_small.png";
import DiamondLink from "../../assets/images/JC_Icon_DiamondLink_small.png";
import PendantBuilder from "../../assets/images/JC_Icon_PendantBuilder_small.png";
import StudBuilder from "../../assets/images/JC_Icon_StudBuilder_small.png";
import JewelryLink from "../../assets/images/Jc_Icon_JewelryLink_small.png";
import { useTranslation } from "react-i18next";
import {
  setChecklinkHeaderMenuData,
  setOpenKeyHeaderMenuData,
  setSelectSideMenu,
} from "../../actions/headerMenu/headerMenu";
import MasterLink from "../../assets/images/JC_Icon_MasterLink_small.png";
import CoreUpgradeModal from "./CoreUpgradeModal";

const AllApps = () => {
  const { t } = useTranslation();
  const [applicationPermisstionResponse, setApplicationPermisstionResponse] =
    useState({});
  const headerDetials = useSelector((state) => state.headerMenuReducer);
  const loginDetials = useSelector((state) => state.loginReducer);
  const dispatch = useDispatch();

  const [upgradeModalVisible, setUpgradeModalVisible] = useState(false);
  const [selectedApp, setSelectedApp] = useState("");

  useEffect(() => {
    if (headerDetials) {
      if (headerDetials.applicationPermisstionResponse) {
        setApplicationPermisstionResponse(
          headerDetials.applicationPermisstionResponse
        );
      }
    }
  }, []);

  // Partner (non-Core) accounts are blocked from every app tile.
  const loginData = loginDetials?.loginDetials?.responseData || {};
  const isPartner =
    headerDetials?.isPartner ??
    headerDetials?.applicationPermisstionResponse?.isPartner ??
    loginData.isPartner ??
    false;
  const isJewelCloudCore =
    headerDetials?.isJewelCloudCore ??
    headerDetials?.applicationPermisstionResponse?.isJewelCloudCore ??
    loginData.isJewelCloudCore ??
    false;
  const blockApps = isPartner && !isJewelCloudCore;

  const handleOpenSideMenu = (Menu) => {
    var MenuData = [`${Menu}`];

    dispatch(setOpenKeyHeaderMenuData(MenuData));
    if (Menu == "Diamond Link") {
      dispatch(setSelectSideMenu(["applicationPreviewDiamondLink"]));
    }
    if (Menu == "Ring Builder") {
      dispatch(setSelectSideMenu(["applicationPreviewRingBuilder"]));
    }
    if (Menu == "Stud Builder") {
      dispatch(setSelectSideMenu(["applicationPreviewStudBuilder"]));
    }
    if (Menu == "Pendant Builder") {
      dispatch(setSelectSideMenu(["applicationPreviewPedantBuilder"]));
    }
     if (Menu == "GemStone Link") {
      dispatch(setSelectSideMenu(["applicationPreviewGemStoneLink"]));
    }
    if ((Menu = "Website Sync")) {
      dispatch(setChecklinkHeaderMenuData("My Catalog"));
      dispatch(setSelectSideMenu(["SyncHistory"]));
    }
  };

  const tiles = [
    {
      colClass: "col-md-3 offset-1",
      img: DiamondLink,
      permKey: "diamondLink",
      to: "/applicationPreviewDiamondLink",
      menu: "Diamond Link",
      title: "Diamond Link",
    },
    {
      colClass: "col-md-3 ",
      img: RingBuilder,
      permKey: "ringBuilder",
      to: "/applicationPreviewRingBuilder",
      menu: "Ring Builder",
      title: "Ring Builder",
    },
    {
      colClass: "col-md-3 ",
      img: PendantBuilder,
      permKey: "pendantBuilder",
      to: "/applicationPreviewPedantBuilder",
      menu: "Pendant Builder",
      title: "Pendant Builder",
    },
    {
      colClass: "col-md-3 offset-1 ",
      img: StudBuilder,
      permKey: "studBuilder",
      to: "/applicationPreviewStudBuilder",
      menu: "Stud Builder",
      title: "Stud Builder",
    },
    {
      colClass: "col-md-3",
      img: MasterLink,
      permKey: "masterLink",
      to: "/MasterLinkApplicationPreview",
      menu: "Master Link",
      title: "Master Link",
    },
    {
      colClass: "col-md-3",
      img: JewelryLink,
      permKey: "jewelryLink",
      to: "/myvendors",
      menu: "Jewelry Link",
      title: "Jewelry Link",
      alt: "jewelryLink",
      // Exempt from the partner block — partner accounts keep JewelryLink
      // (still subject to its own permission flag).
      alwaysEnabled: true,
    },
    {
      colClass: "col-md-3 offset-1",
      img: DiamondLink,
      permKey: "gemstoneLink",
      to: "/applicationPreviewGemStoneLink",
      menu: "GemStone Link",
      title: "GemStone Link",
    },
  ];

  // A tile is blocked by the partner gate unless it is explicitly exempt.
  const isTileBlocked = (tile) => blockApps && !tile.alwaysEnabled;

  const isTileDisabled = (tile) =>
    isTileBlocked(tile) || applicationPermisstionResponse[tile.permKey] == false;

  const handleTileClick = (e, tile) => {
    if (isTileBlocked(tile)) {
      e.preventDefault();
      setSelectedApp(tile.title);
      setUpgradeModalVisible(true);
      return;
    }
    if (applicationPermisstionResponse[tile.permKey] == false) {
      e.preventDefault();
      return;
    }
    handleOpenSideMenu(tile.menu);
  };

  const renderTile = (tile) => {
    const disabled = isTileDisabled(tile);
    return (
      <div className={tile.colClass} key={tile.permKey}>
        <div className="apps__block">
          <NavLink
            title={
              isTileBlocked(tile)
                ? t("Available to JewelCloud Core members only")
                : disabled
                ? `${tile.title} Not Access`
                : tile.title
            }
            to={disabled ? "#" : tile.to}
            onClick={(e) => handleTileClick(e, tile)}
            style={{ display: "inline-block" }}
          >
            <img
              alt={tile.alt || tile.title}
              src={tile.img}
              width="150"
              className={disabled ? "any-disable" : "app-image"}
              style={{
                cursor: disabled ? "not-allowed" : "pointer",
              }}
            />
          </NavLink>
        </div>
      </div>
    );
  };

  return (
    <React.Fragment>
      <div className="form__fields magento__mapping allapps__section p-5">
        <div className="row m-5">{tiles.slice(0, 3).map(renderTile)}</div>
        <div className="row m-5">{tiles.slice(3).map(renderTile)}</div>
      </div>
      <CoreUpgradeModal
        visible={upgradeModalVisible}
        onClose={() => setUpgradeModalVisible(false)}
        appName={selectedApp}
      />
    </React.Fragment>
  );
};

export default AllApps;
